import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ItineraryType } from '../../entities/control-tables/itinerary-type';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class ItineraryTypeRequest extends BaseRequest {

    itineraryType : ItineraryType

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.itineraryType = new ItineraryType()
  }
}